import { carticon } from "assets/icons/index";
import DonationCart from "./DonationCart";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import { useTranslation } from "react-i18next";
import { userGetCartItemsActions } from "redux/actions/Cart/userGetCartItemsActions";

const Cart = () => {
  const [showDonationCart, setShowDonationCart] = useState(false);
  const { i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const { cart } = useSelector((state: RootState) => state.guestCartReducer);
  const { loginData, userId } = useSelector(
    (state: RootState) => state.loginReducer
  );

  /////////////////// user cart items

  useEffect(() => {
    if (userId) {
      dispatch(userGetCartItemsActions(userId));
    }
  }, [dispatch, userId]);

  const { userCartItems } = useSelector(
    (state: RootState) => state.userGetCartItemsReducer
  );

  useEffect(() => {
    dispatch(userGetCartItemsActions(userId));
  }, []);

  return (
    <div>
      {/* the cart icon  */}
      <div
        onClick={() => setShowDonationCart(!showDonationCart)}
        className="relative cursor-pointer"
      >
        <img className="min-w-[20px]" src={carticon} alt="logo" />
        <div
          className={`absolute top-[-30%] right-[-50%] w-[15px] h-[15px] bg-first_color rounded-full flex items-center justify-center text-white text-[11px] font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600]`}
        >
          {loginData
            ? userCartItems?.cart_summary?.total_items
            : cart.totalItems}
        </div>
      </div>

      {/* donation cart menu  */}
      {showDonationCart && (
        <DonationCart show={showDonationCart} setShow={setShowDonationCart} />
      )}
    </div>
  );
};

export default Cart;
